import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";
import reveal from "./reveal";
import header from "./header";
import popups from "./popups";
import scroll from "./scroll";
import cart from "./cart";
import filters from "./filters";
import checkout from "./checkout";

gsap.registerPlugin(ScrollTrigger, SplitText, ScrambleTextPlugin);

const motion = {
    init() {
        const root = document.documentElement;

        if (!this.enabled()) {
            root.classList.remove('ex-motion');
            return;
        }

        gsap.config({ nullTargetWarn: false });
        gsap.defaults({ ease: 'power3.out', duration: 0.9 });
        ScrollTrigger.config({ ignoreMobileResize: true });

        try {
            reveal.init(root.classList.contains('ex-motion'));
        } catch (error) {
            reveal.reset();
        }

        root.classList.remove('ex-motion');

        header.init();
        popups.init();
        scroll.init();
        cart.init();
        filters.init();
        checkout.init();
    },

    enabled() {
        const body = document.body;

        return typeof window.matchMedia === 'function'
            && window.matchMedia('(prefers-reduced-motion: no-preference)').matches
            && !body.classList.contains('elementor-editor-active')
            && !body.classList.contains('elementor-editor-preview');
    },
};

export default motion;
